module.exports = __webpack_public_path__ + "img/female.5097b024.jpg";